// extracted by mini-css-extract-plugin
export default {"mainWrapper":"RequestEditDetails_mainWrapper__2PK3H"};